export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7439.fde85f84.jpg";